import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Button,
  Space,
  Divider
} from '@lockerpm/design';

import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";
import formsComponents from "../../../../../components/forms";

import global from "../../../../../config/global";
import paymentServices from "../../../../../services/payment";

const PaymentMethods = (props) => {
  const {
    CreditCard
  } = itemsComponents;
  const {
    CreditCardForm
  } = formsComponents;
  const {
    className
  } = props;
  const { t } = useTranslation();

  const [collapseKeys, setCollapseKeys] = useState([]);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    fetchCards();
  }, [])

  const fetchCards = async () => {
    setLoading(true);
    await paymentServices.get_payments_cards().then((res) => {
      setCards(res);
    }).catch(() => {
      setCards([])
    })
    setLoading(false);
  }

  const handleOpenForm = (item) => {
    setSelectedCard(item);
    setFormVisible(true)
  }

  const CollapseHeader = () => {
    return <p className="font-semibold">{t('plans_billing.payment_methods.title')}</p>
  }

  const deleteCard = (card) => {
    global.confirm(async () => {
      paymentServices
        .remove_payments_card(card.id_card)
        .then(async () => {
          global.pushSuccess(t("notification.success.payments.deleted_card"))
          fetchCards();
        })
        .catch((error) => {
          global.pushError(error)
        })
    }, {
      title: t('plans_billing.payment_methods.delete_card'),
      content: t('plans_billing.payment_methods.delete_question'),
      okText: t('button.ok'),
      okButtonProps: { danger: true },
    })
  } 

  const CollapseBody = () => {
    return <div>
      {
        cards.map((card, index) => <div
          key={index}
        >
          <div
            className="flex item-center justify-between"
          >
            <CreditCard
              className="md:w-[400px] w-[250px]"
              card={card}
            />
            <Space size={[12, 12]}>
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => handleOpenForm(card)}
              />
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                onClick={() => deleteCard(card)}
              />
            </Space>
          </div>
          <Divider />
        </div>)
      }
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => handleOpenForm(null)}
      >
        {t('billing.add_btn')}
      </Button>
    </div>
  }

  return (
    <div className={`payment-methods ${className}`}>
      <Collapse
        activeKey={collapseKeys}
        expandIconPosition={'end'}
        loading={loading}
        onChange={setCollapseKeys}
      >
        <Collapse.Panel
          key="1"
          header={<CollapseHeader/>}
        >
          <CollapseBody />
        </Collapse.Panel>
      </Collapse>
      <CreditCardForm
        visible={formVisible}
        card={selectedCard}
        onReload={fetchCards}
        onClose={() => setFormVisible(false)}
      />
    </div>
  );
}

export default PaymentMethods;